import { Injectable } from '@angular/core'
import { RelationMap } from '../interfaces/related-entity'

@Injectable({ providedIn: 'root' })
export abstract class BaseEffects<_T extends { isLoading: boolean; error: string | null }> {
  protected populateRelations(entity: any, relations: RelationMap) {
    if (!entity || typeof entity !== 'object') return

    Object.keys(relations).forEach((relationName) => {
      const config = relations[relationName]
      const data = entity[relationName]

      if (Array.isArray(data) && data.length > 0) {
        config.setter(data)
        console.log(`Populate ${relationName}: ${data.length} elements`)
      }
    })
  }
}
